import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import BannerBlockForm from '../../../components/BannerBlocks/BannerBlockForm';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import Spinner from '../../../components/Spinner';
import { DEFAULT_CHROME_CSS_STYLES } from '../../../constants/bannerChrome';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const BannerBlocksNewPage = ({ type = 'bannerBlocks' }) => {
  const pageTitle = `${Page[type]}`;
  const fetch = useFetch();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [segments, setSegments] = useState();
  const [page, setPage] = useState();
  const { accountId, domainId, pageId } = useParams();

  const typeName = type === 'postPurchases' ? 'Post Purchase' : 'BannerBlock';

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch((error) => {
        setError(error);
      });

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages/${pageId}`)
      .then(({ page }) => {
        setPage(page);
      })
      .catch((error) => {
        setError(error);
      });
  }, [fetch, accountId, domainId, pageId]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (segments === undefined || page === undefined) {
    return <Spinner />;
  }

  const bannerBlock = {
    name: `New banner block`,
    tags: [],
    pageId,
    displayType: 'static',
    trigger: 'immediately',
    cssSelector: '',
    displayStrategy: 'afterbegin',
    delaySeconds: 0,
    scrollPercentage: 0,
    urlCondition: 'any',
    advancedStyling: false,
    cssStyles: { ...DEFAULT_CHROME_CSS_STYLES },
    inverseSegmentSelection: false,
    storeLocales: [],
  };

  return (
    <>
      <Metadata title={`${pageTitle} | New`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor
          href={`#/accounts/${accountId}/domains/${domainId}/pages?type=${type}&page=${bannerBlock?.pageId || ''}`}
        >
          {page.name} {typeName}
        </Anchor>
        <Text>New</Text>
      </Breadcrumbs>

      <BannerBlockForm
        type={type}
        bannerBlock={bannerBlock}
        segments={segments}
        cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/pages?type=${type}`)}
      />
    </>
  );
};

export default BannerBlocksNewPage;
